











































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { mapGetters, mapState, mapMutations, mapActions } from 'vuex';
import {IServer, ISystemMemory} from './shared/services/models/Server';
import {ISetting} from './shared/services/models/Setting';
import {IEvent} from './shared/services/models/Event';
import moment from 'moment';


// The @Component decorator indicates the class is a Vue component
@Component({
    computed: {
        ...mapState(['username', 'serverStatus', 'settings', 'newEvents']),
    },
    methods: {
        ...mapActions(['updateServerStatus', 'updateSettings', 'updateEvents', 'updateCinegyRouteSources', 'updateCinegyRouteDestinations', 'resetStatus']),
    },
})
// @ts-ignore
export default class AppComponent extends Vue {
    private serverStatus!: IServer;
    private settings!: ISetting[];
    private newEvents!: IEvent[];
    private lastEventTimestamp: string|undefined;

    private updateHandle: number = 0;
    private updateEventsHandle: number = 0;

    private pageVisible: boolean = true;
    private pageHiddenAt: Date = new Date();

    private ListViewDetailsKey: string = 'ui.interfaces.details.mode';
    private StickyBarKey: string = 'ui.titlebar.sticky';
    private TitleKey: string = 'ui.titlebar.title';
    private ToastKey: string = 'ui.toast';


    private mounted() {
        document.addEventListener('visibilitychange', this.handleVisibility, false);

        this.startUpdates();
    }

    private startUpdates(): void {
        // @ts-ignore
        this.updateSettings();
        // @ts-ignore
        this.updateCinegyRouteSources();

        // @ts-ignore
        this.updateCinegyRouteDestinations();

        // @ts-ignore
        this.updateServerStatus();

        // @ts-ignore
        this.updateHandle = setInterval(() => {
            // @ts-ignore
            this.updateSettings();

           // if (this.ListViewDetails === 'list') {
                // @ts-ignore
            this.updateServerStatus();
           // }

            // @ts-ignore
            // this.updateEvents();
        }, 5000);

        // @ts-ignore
        this.updateEventsHandle = setInterval(() => {
            // @ts-ignore
            this.updateEvents();

            if (this.newEvents && this.newEvents.length > 0) {
                this.newEvents.forEach((e) => {
                    if (!this.lastEventTimestamp) {
                        this.showEvent(e.type, e.message);
                        this.lastEventTimestamp = e.timestamp;
                    } else if ((new Date(this.lastEventTimestamp)) < (new Date(e.timestamp)) ) {
                        this.showEvent(e.type, e.message);
                        this.lastEventTimestamp = e.timestamp;
                    }
                });
            }
        }, 2500);
    }

    private handleVisibility(): void {
        if (document.visibilityState === 'hidden') {
            this.pageVisible = false;
            clearInterval(this.updateHandle);
            clearInterval(this.updateEventsHandle);

            this.updateHandle = -1;
            this.updateEventsHandle = -1;
            window.console.log('Page Hidden');
            this.pageHiddenAt = new Date();
        } else {
            this.pageVisible = true;
            this.startUpdates();
            window.console.log('Page Visible');
            const now = new Date();
            const duration = moment.duration(moment(now).diff(moment(this.pageHiddenAt)));
            if (duration.asMinutes() > 5) {
                // @ts-ignore
                this.resetStatus();
            }
        }
    }

    private get PageVisible(): boolean {
        return this.pageVisible;
    }

    private get Settings(): { [key: string]: string } {
        const ret: { [key: string]: string } = {};

        if (this.settings && Array.isArray(this.settings)) {
            this.settings.forEach((s) => {
                ret[s.key] = s.value;
            });
        }

        return ret;
    }

    private get ListViewDetails(): string {
        const s = this.Settings;

        if (s.hasOwnProperty(this.ListViewDetailsKey)) {
            return s[this.ListViewDetailsKey];
        }

        return '';
    }

    private get StickyBar(): boolean {
        const s = this.Settings;

        if (s.hasOwnProperty(this.StickyBarKey)) {
            return s[this.StickyBarKey] === 'true';
        }

        return false;
    }

    private get BarTitle(): string {
        const s = this.Settings;

        if (s.hasOwnProperty(this.TitleKey)) {
            document.title = s[this.TitleKey];
            return s[this.TitleKey];
        }

        document.title = '';
        return '';
    }

    private get ToastMode(): string {
        const s = this.Settings;

        if (s.hasOwnProperty(this.ToastKey)) {
            return s[this.ToastKey];
        }

        return 'all';
    }

    private get ServerStatus(): { [key: string]: string } {
        const ret: { [key: string]: string } = {};
        if (this.serverStatus && Array.isArray(this.serverStatus.cpu)) {
            this.serverStatus.cpu.forEach((c) => {
                if (c && c.length === 11 && c[0] === 'all') {
                    ret[`idle`] = c[10];
                }
            });
        }
        return ret;
    }

    private get SensorTiles(): { [key: string]: string } {
        const ret: { [key: string]: string } = {};
        if (this.serverStatus && this.serverStatus.sensors) {
            Object.keys(this.serverStatus.sensors).forEach((element) => {
                Object.keys(this.serverStatus.sensors[element]).forEach((key) => {
                    if (key.toLowerCase().indexOf('core') !== -1 && typeof this.serverStatus.sensors[element][key] !== 'string') {

                        Object.keys(this.serverStatus.sensors[element][key]).forEach((temp) => {
                            if (typeof temp === 'string' && temp.indexOf('_input') !== -1 && temp.indexOf('temp') !== -1) {
                                ret[key] = this.serverStatus.sensors[element][key][temp];
                            }
                        });
                    }
                });
            });
        }
        return ret;
    }

    private get MemoryStatusTiles(): ISystemMemory {
        if (this.serverStatus) {
            return this.serverStatus.memory;
        }

        return {
            MemTotal: '0',
            MemFree: '0',
            MemAvailable: '0',
            Cached: '0',
            Buffers: '0',
            SwapCached: '0',
            SwapTotal: '0',
            SwapFree: '0',
        };
    }

    private get CPUStatusTitles(): { [key: string]: string } {
        const ret: { [key: string]: string } = {};
        if (this.serverStatus && Array.isArray(this.serverStatus.cpu)) {
            this.serverStatus.cpu.forEach((c) => {
                if (c && c.length === 11 && c[0] === 'CPU') {
                    ret[`Core`] = '';
                /* ret[`${c[1].replace('%', '')}`] = '';
                    ret[`${c[2].replace('%', '')}`] = '';
                    ret[`${c[3].replace('%', '')}`] = '';
                    ret[`${c[10].replace('%', '')}`] = '';*/
                    ret[`Load`] = '';
                }
            });
        }
        return ret;
    }

    private get CPUStatus(): { [key: string]: string[] } {
        const ret: { [key: string]: string[] } = {};
        if (this.serverStatus && Array.isArray(this.serverStatus.cpu)) {
            this.serverStatus.cpu.forEach((c) => {
                if (c && c.length === 11 && c[0] !== 'all' && c[0] !== 'CPU') {
                    ret[`#${c[0]}`] = [];
                    ret[`#${c[0]}`].push('#' + c[0]);
                /* ret[`#${c[0]}`].push(c[1]);
                    ret[`#${c[0]}`].push(c[2]);
                    ret[`#${c[0]}`].push(c[3]);*/
                    ret[`#${c[0]}`].push((100 - parseFloat(c[10])).toFixed(1) + '%');
                }
            });
        }
        return ret;
    }

    private toast(title: string, message: string): void {
        this.$bvToast.toast(message, {
            title,
            variant: 'success',
            solid: true,
            toaster: 'b-toaster-bottom-right',
        });
    }

    private isUserEvent(e: string): boolean {
        switch (e) {
            case 'start requested':
            case 'stop requested':
            case 'restart requested':
            case 'save requested': return true;
            default: break;
        }
        return false;
    }

    private showEvent(title: string, message: string) {
        switch (this.ToastMode) {
            case 'all': this.toast(title, message); break;
            case 'user': if (this.isUserEvent(title)) {this.toast(title, message); } break;
            default: break;
        }
    }

    private destroyed() {
        clearInterval(this.updateHandle);
        clearInterval(this.updateEventsHandle);
    }
}
